import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  CircularProgress,
  IconButton,
  TextField,
  InputAdornment,
  Button,
  Checkbox,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import SearchIcon from "@mui/icons-material/Search";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function MobileMarketingTags() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectMode, setSelectMode] = useState(false);
  const [finalizeMode, setFinalizeMode] = useState(false);
  const [selected, setSelected] = useState([]);

  const fetchMarketingProducts = async () => {
    try {
      setLoading(true);
      // folosim search; backend-ul trebuie să includă și coloana `tags` în căutare
      const res = await axios.get(
        "https://server-9p4hx.kinsta.app/api/stocmanager/products-by-tag",
        {
          params: { tag: "marketing", limit: 200 },
        }
      );
      const rows = Array.isArray(res.data?.results)
        ? res.data.results
        : res.data; // fallback pentru implementări vechi
      setProducts(rows || []);
    } catch (err) {
      console.error("Eroare încărcare produse marketing:", err);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async (items) => {
    try {
      const cleaned = (items || []).filter(
        (it) => it && it.sku && it.productId
      );
      if (cleaned.length === 0) {
        console.warn("Nimic de exportat: lipsesc SKU/ProductId");
        return;
      }
      if (cleaned.length !== items.length) {
        console.warn(
          `Ignor ${items.length - cleaned.length} element(e) fără SKU/ID`
        );
      }

      const res = await axios.post(
        "https://server-9p4hx.kinsta.app/api/stocmanager/bundle-pdfs",
        { items: cleaned },
        { responseType: "blob" }
      );
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "bundle.zip");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Eroare export bundle:", err);
    }
  };

  useEffect(() => {
    fetchMarketingProducts();
  }, []);

  const filtered = products.filter((p) => {
    const q = searchTerm.toLowerCase();
    return (
      (p.product_name || "").toLowerCase().includes(q) ||
      (p.sku || "").toLowerCase().includes(q) ||
      (p.folder_name || "").toLowerCase().includes(q)
    );
  });

  const getRowId = (item) => item?.id ?? item?.productId ?? item?._id;

  return (
    <Box
      sx={{
        color: "#fff",
        "& .MuiTypography-root": { color: "#fff" },
        "& .MuiSvgIcon-root": { color: "#fff" },
        "& .MuiIconButton-root": { color: "#fff" },
        "& .MuiInputBase-input": { color: "#fff" },
        "& .MuiInputBase-input::placeholder": {
          color: "rgba(255,255,255,0.7)",
          opacity: 1,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(255,255,255,0.6)",
        },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#fff",
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
          {
            borderColor: "#fff",
          },
        "& .MuiCheckbox-root": { color: "#fff" },
      }}
    >
      <Container
        disableGutters
        sx={{
          p: 0,
          pt: 2,
          width: "100vw",
          maxWidth: "100vw",
          overflowX: "hidden",
        }}
      >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        mb={2}
      >
        <Typography variant="subtitle1" fontWeight="bold">
          Produse cu tag „marketing”
        </Typography>
        <IconButton onClick={() => navigate("/")}>
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box px={2} mb={2}>
        <TextField
          fullWidth
          size="small"
          placeholder="Filtrează local după titlu / SKU / folder"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          sx={{
            "& .MuiInputAdornment-root .MuiSvgIcon-root": {
              color: "#0B3D91",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box
        px={2}
        mb={2}
        display="flex"
        justifyContent="space-around"
        alignItems="center"
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={0.5}
          onClick={() => {
            if (selectMode) {
              const items = products
                .filter((p) => selected.includes(p.id))
                .map((p) => ({ sku: p.sku, productId: p.id }));
              handleExport(items);
            } else {
              setSelectMode(true);
            }
          }}
          sx={{ cursor: "pointer" }}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckCircleOutlineIcon
              sx={{ fontSize: 28, color: "#0B3D91 !important" }}
            />
          </Box>
          <Typography variant="caption" sx={{ fontWeight: 600 }}>
            {selectMode ? "Export" : "Select"}
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={0.5}
          onClick={() => {
            const items = products.map((p) => ({
              sku: p.sku,
              productId: p.id,
            }));
            handleExport(items);
          }}
          sx={{ cursor: "pointer" }}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <FileDownloadIcon
              sx={{ fontSize: 28, color: "#0B3D91 !important" }}
            />
          </Box>
          <Typography variant="caption" sx={{ fontWeight: 600 }}>
            Export All
          </Typography>
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={0.5}
          onClick={async () => {
            if (finalizeMode) {
              // finalize selected products: send SKUs to backend to remove marketing tag
              const items = products.filter((p) => selected.includes(p.id));
              const skus = items.map((p) => p.sku).filter(Boolean);
              try {
                await axios.delete(
                  "https://server-9p4hx.kinsta.app/api/stocmanager/products/delete/tags",
                  { data: { skus, tag: "marketing" } }
                );
                console.log("Removed marketing tag for SKUs:", skus);
                fetchMarketingProducts();
              } catch (err) {
                console.error("Eroare la ștergere tag marketing:", err);
              }
              setFinalizeMode(false);
              setSelected([]);
            } else {
              setFinalizeMode(true);
            }
          }}
          sx={{ cursor: "pointer" }}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "50%",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PictureAsPdfIcon
              sx={{ fontSize: 28, color: "#0B3D91 !important" }}
            />
          </Box>
          <Typography variant="caption" sx={{ fontWeight: 600 }}>
            Finalizat
          </Typography>
        </Box>
        {(selectMode || finalizeMode) && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={0.5}
            onClick={() => {
              setSelectMode(false);
              setFinalizeMode(false);
              setSelected([]);
            }}
            sx={{ cursor: "pointer" }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 700, color: "#0B3D91" }}>
                X
              </Typography>
            </Box>
            <Typography variant="caption" color="text.secondary">
              Închide
            </Typography>
          </Box>
        )}
      </Box>

      {loading ? (
        <Box px={2}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box px={2} pb={6}>
          {filtered.length === 0 && (
            <Typography variant="body2" color="text.secondary">
              Nu există produse marcate cu „marketing”.
            </Typography>
          )}
          {filtered.map((p) => {
            const rowId = getRowId(p);
            return (
            <Paper
              key={rowId}
              sx={{
                p: 1.5,
                mb: 1.5,
                cursor: selectMode || finalizeMode ? "default" : "pointer",
                "& .MuiTypography-root": { color: "#0B3D91" },
              }}
              onClick={() => {
                if (!(selectMode || finalizeMode)) {
                  navigate(`/mobile-product/${rowId}`);
                } else {
                  // toggle selection
                  if (selected.includes(rowId)) {
                    setSelected(selected.filter((id) => id !== rowId));
                  } else {
                    setSelected([...selected, rowId]);
                  }
                }
              }}
            >
              <Box display="flex" alignItems="center" gap={2}>
                {(selectMode || finalizeMode) && (
                  <Checkbox
                    checked={selected.includes(rowId)}
                    sx={{
                      color: "#0B3D91",
                      "&.Mui-checked": {
                        color: "#0B3D91",
                      },
                      backgroundColor: "#fff",
                      borderRadius: "50%",
                      padding: "6px",
                      "&.Mui-checked": {
                        backgroundColor: "#0B3D91",
                        color: "#fff",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: 22,
                        color: "#0B3D91",
                      },
                      "&.Mui-checked .MuiSvgIcon-root": {
                        color: "#fff",
                        fontSize: 24,
                      },
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      },
                    }}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelected([...selected, rowId]);
                      } else {
                        setSelected(selected.filter((id) => id !== rowId));
                      }
                    }}
                  />
                )}
                {p.image_url ? (
                  <Box
                    component="img"
                    src={p.image_url}
                    alt={p.product_name || ""}
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 1,
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 1,
                      backgroundColor: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <PhotoCameraIcon sx={{ fontSize: 24, color: "#0B3D91" }} />
                  </Box>
                )}
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography fontWeight={600} noWrap>
                    {p.product_name || "(fără titlu)"}
                  </Typography>
                  <Typography
                    variant="body2"
                    noWrap
                  >
                    SKU: {p.sku || "-"} • Folder: {p.folder_name || "-"}
                  </Typography>
                </Box>
                <Typography variant="body2">
                  {Number(p.price || 0).toLocaleString()} RON
                </Typography>
              </Box>
            </Paper>
          );
          })}
        </Box>
      )}
      </Container>
    </Box>
  );
}

export default MobileMarketingTags;
